import { learningObjectivesIntro, activitiesListIntro, standardActivities, initialPost, standardActivitiesClosing, closing } from './AL00000Sprint00'
import { oreillyPlaylistOOP, externalLink } from '../DataAndAPIs/Links'
import { swissArmyKnifeV2Link } from '../Activities/SwissArmyKnife'
import { finalProjectProposalLink } from '../Activities/FinalProjectProposal'
import { thunderbirdLink } from '../Activities/Thunderbird'	

export const al24500Sprint06 = ( props ) => {
	const sprint = 6

	return ( <div>
		<h5>Sprint 6: Thunderbird and Final Project Proposal Reviews</h5>
		<p><em>Welcome to sprint 6.</em> How time flies. We have a new type of programming activity this sprint called Thunderbird. 
		Thunderbird is different than previous assignments in that we will be enhancing an existing
		application rather than creating a new application from scratch. This is more like what you would expect day-to-day in an
		entry level professional programming position. I think you will enjoy learning about and enhancing an existing 
		application.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{ listStyleType: 'square' }}>
			<li>Enhance existing Java applications</li>
			<li>Understand multithreaded Java applications</li>
			<li>Understand Java Servlets</li>
			<li>Develop and enhance intermediate level graphical, distributed, multi-threaded Java applications</li>
			<li>Understand View and Model classes that conform to the model-view-controller pattern</li>
		</ul>
		{list24500Sprint06(sprint)}
		{closing(sprint)}
	</div> )
}

export const list24500Sprint06 = (sprint) => {
	const javaServletOnAzureQuickStart = () => { return externalLink('Quickstart: Create a Java app on Azure App Service', 
		'https://learn.microsoft.com/en-us/azure/app-service/quickstart-java?tabs=javase&pivots=platform-windows-development-environment-azure-portal')}

	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, thunderbirdLink(), oreillyPlaylistOOP())}
			<li>Consider completing {swissArmyKnifeV2Link()} as an alternative to {thunderbirdLink()}</li>
			<li>Within {oreillyPlaylistOOP()} read “Learning Java” chapter 12 “Programming the Web” focusing on Java Servlets</li>
			<li>Scan {javaServletOnAzureQuickStart()}</li>

			{initialPost(sprint)}
			<li>Review and update {finalProjectProposalLink()}</li>
			{standardActivitiesClosing(sprint, thunderbirdLink(), '8 hours')}
		</ol>
	</div> )
}

// Certified for FA26 on November 2, 2026